import { useId, useState } from "react";
import { ACCENT } from "../constants/theme";

export default function Select({ label, value, onChange, options, required }) {
  const [focused, setFocused] = useState(false);
  const selectId = useId();

  return (
    <div style={{ marginBottom: 18 }}>
      <label
        htmlFor={selectId}
        style={{
          display: "block",
          fontWeight: 600,
          fontSize: 13.5,
          color: "#374151",
          marginBottom: 6,
        }}
      >
        {label}
        {required && (
          <span style={{ color: ACCENT }} aria-hidden="true">
            {" "}
            *
          </span>
        )}
      </label>

      <select
        id={selectId}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        required={required}
        aria-required={required ? "true" : "false"}
        style={{
          width: "100%",
          padding: "12px 16px",
          borderRadius: 10,
          fontSize: 15,
          fontFamily: "inherit",
          border: `1.5px solid ${focused ? ACCENT : "#e2e8f0"}`,
          outline: "none",
          background: "#fff",
          color: value ? "#0f172a" : "#94a3b8",
          transition: "border 0.15s",
          boxSizing: "border-box",
          cursor: "pointer",
        }}
      >
        <option value="" disabled>
          Select an option
        </option>

        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </div>
  );
}